import React from 'react';
import './Privacy.css';

function Terms() {
    return (
        <div className="legal-wrapper">
            <div className="legal-container">
                <h1>Terms of Service</h1>
                <p><strong>Last Updated:</strong> 11.05.2025</p>

                <h2>1. Acceptance</h2>
                <p>
                    By using RanchersLand (“we”, “our”, “us”), you agree to these Terms of Service. If you do not agree, please do not use the website or associated services.
                </p>

                <h2>2. Game Access & Wallets</h2>
                <p>
                    RanchersLand is a blockchain-based game that requires a WAX-compatible wallet (e.g., WAX Cloud Wallet or Anchor) for login and gameplay. We do not control or operate any wallet provider, and your use of such services is subject to their respective terms.
                </p>

                <h2>3. No Asset Custody</h2>
                <p>
                    We do not hold or manage any user assets. All game-related items and transactions are conducted directly on the WAX blockchain. You are solely responsible for your wallet and private keys.
                </p>

                <h2>4. NFT Gameplay</h2>
                <p>
                    RanchersLand uses NFTs for gameplay interactions. All assets, actions, and rewards are executed through smart contracts and are verifiable on-chain. We do not store or manage NFTs or transaction history.
                </p>

                <h2>5. No Personal Data Collection</h2>
                <p>
                    We do not collect or process any personal data. Please refer to our <a href="/privacy">Privacy Policy</a> for details.
                </p>

                <h2>6. Gameplay Rules</h2>
                <p>
                    Users are expected to play fairly. Exploits, bots, or any attempts to manipulate smart contracts may result in restricted access or blocked functionality.
                </p>

                <h2>7. Disclaimers</h2>
                <p>
                    RanchersLand is provided "as is" without warranties of any kind. We do not guarantee uptime, asset value, or continuous service. Blockchain transactions are irreversible, and we are not liable for user errors.
                </p>

                <h2>8. Changes to Terms</h2>
                <p>
                    We may update these Terms periodically. Continued use of RanchersLand after updates constitutes acceptance of the new Terms.
                </p>

                <h2>9. Contact</h2>
                <p>
                    For questions or concerns, contact us at <a href="mailto:rancherland@gmail.com">rancherland@gmail.com</a>.
                </p>
            </div>
        </div>
    );
}

export default Terms;
